"use client";
import { Stack, Icon, Box } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import { MdOutlineDoneAll } from "@onemind-services-llc/react-icons-ng/md";
import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";

type DescriptionProps = {
  points: { label: string; text: string }[];
};

const Content = (props: DescriptionProps) => {
  const { points } = props;
  const textVariant = useTextVariant();
  return (
    <Stack>
      {points.map((point, i) => (
        <Box color={"text.100"} key={i}>
          <Text variant={textVariant} as="span" fontWeight={600}>
            <Box as="span" display="inline-flex" alignItems="center" mt={2} mr={2}>
              <Icon as={MdOutlineDoneAll} />
            </Box>
            {point.label} -{" "}
          </Text>
          <Text variant={textVariant} as="span">
            {point.text}
          </Text>
        </Box>
      ))}
    </Stack>
  );
};

export const SOLUTIONS_CONSTANTS = {
  title: "Onemind’s Cloud Storage Solutions – How We Help You",
  desc: "At Onemind, we provide cost-effective, high-performance cloud storage solutions that support AI/ML, big data, backups, and enterprise applications.",
  list: [
    {
      image: Img1,
      title: "Block Storage – Ultra-Low Latency for High-Performance Applications",
      content: (
        <Content
          points={[
            {
              text: "Optimized for high-speed transactional databases and cloud VMs.",
              label: "NVMe-Powered Storage",
            },
            {
              text: "Works seamlessly with MySQL, PostgreSQL, SAP, Oracle, and Kubernetes clusters.",
              label: "Ideal for Virtual Machines & Databases",
            },
            {
              text: "RAID-10 architecture, instant snapshots, and rapid cloning.",
              label: "Data Protection & Recovery",
            },
            {
              text: "AES-256 encryption, SOC2 compliance, and multi-layer redundancy.",
              label: "Enterprise-Grade Security",
            },
          ]}
        />
      ),
    },
    {
      image: Img2,
      title: "S3-Compatible Object Storage – Scalable, Secure & Cost-Effective",
      content: (
        <Content
          points={[
            {
              text: "Seamless integration with cloud applications & hybrid environments.",
              label: "AWS S3 & OpenStack Swift API Compatibility",
            },
            {
              text: "Store petabytes of data without manual scaling.",
              label: "Built for AI, Backup & Archiving",
            },
            {
              text: "Isolated environments with zero multi-tenant interference.",
              label: "Private Object Storage for High Security",
            },
            {
              text: "Multi-region replication ensures disaster recovery readiness.",
              label: "Geo-Redundant Storage",
            },
          ]}
        />
      ),
    },
  ],
};
